export enum PrivilegeConfig {
  MANAGE_SUBSCRIPTION = 'fastr:manage-subscription',
  MANAGE_WORKSPACE = 'fastr:manage-workspace',
}
